import { Headline } from './styles';

export default Headline;
